<div mat-dialog-title class="filter-dialog-title">
  <h2>Search</h2>
  <button mat-icon-button matDialogClose="{}" aria-label="close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form (ngSubmit)="search()">
    <mat-form-field
      class="search"
      [ngClass]="{ 'search-background': themeClass === 'light-theme' }"
    >
      <mat-label>Search</mat-label>
      <input
        #searchInput
        matInput
        placeholder="Search"
        [formControl]="searchControl"
        [matAutocomplete]="searchAutocomplete"
      />
      <button
        type="button"
        matSuffix
        mat-icon-button
        aria-label="search"
        (click)="search()"
      >
        <mat-icon>search</mat-icon>
      </button>
      <button
        type="button"
        matSuffix
        mat-icon-button
        aria-label="search"
        (click)="clear()"
      >
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-form-field>
    <mat-autocomplete
      autoActiveFirstOption
      #searchAutocomplete="matAutocomplete"
      (optionSelected)="selectResult($event.option.value)"
    >
      <mat-optgroup *ngIf="searchResultsInContext?.length" label="In this view">
        <mat-option
          *ngFor="let option of searchResultsInContext"
          [value]="option"
        >
          <div matListItemTitle>{{ option.title }}</div>
        </mat-option>
      </mat-optgroup>

      <mat-optgroup
        *ngIf="searchResultsNotInContext?.length"
        label="Not in this view"
      >
        <mat-option
          *ngFor="let option of searchResultsNotInContext"
          [value]="option"
        >
          <div matListItemTitle>{{ option.title }}</div>
        </mat-option>
      </mat-optgroup>
    </mat-autocomplete>
  </form>
</mat-dialog-content>
